import { t } from '../../i18n-t';
import type { FormConfig } from '../types';

export const getActionUpdateFormConfig = () => {
  return {
    Title: {
      fieldId: 'Title',
      formLabel: t(`fields.Title`),
      columnHeader: t(`actionUpdates.columns.title`),
    },
    Description: {
      fieldId: 'Description',
      formLabel: t(`fields.Description`),
      columnHeader: t(`actionUpdates.columns.description`),
      displayType: { displayType: 'textarea' },
    },
    files: {
      fieldId: 'files',
      formLabel: t(`fields.newFiles`),
    },
  } as const satisfies FormConfig;
};
